import { __ } from '@wordpress/i18n';
import { getTranslation } from '../../../languages';
import { useState } from '@wordpress/element';
import { Link, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';

const Categories = ({
    isLoadingCategories,
    categories
}) => {

    const [toggle, setToggle] = useState({
        isOpen: false,
        btnText: getTranslation('+ Fler', 'dalslandskanal-custom-blocks/categories')
    });

    let [searchParams] = useSearchParams();
    const type = searchParams.get('typ') ? searchParams.get('typ') : null;


    if (isLoadingCategories) {
        return (
            <div className="categories categories--is-loading">
                <ul className="categories__skeleton">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
        );
    }

    if (!categories) {
        return null;
    }

    return (
        <div className={classNames({
            'categories': true,
            'categories--is-open': toggle.isOpen
        })}>
            <ul className="categories__list">
                <li>
                    <Link 
                        className={classNames({
                            'categories__list-item': true,
                            'categories__list-item--selected': !type
                        })} 
                        to={window.location.pathname}>Alla</Link>
                </li>
                {categories.map(category => {
                    return (
                        <li key={category.id}>
                            <Link className={classNames({
                                'categories__list-item': true,
                                'categories__list-item--selected': category.id.toString() === (type && type.toString())
                            })} to={`?typ=${category.id}`}>{category.name}</Link>
                        </li>
                    );
                })}
                <li>
                    <button className="categories__toggler categories__toggler--less" type="button" onClick={() => {
                        setToggle({
                            isOpen: !toggle.isOpen,
                            btnText: toggle.isOpen ? getTranslation('+ Fler', 'dalslandskanal-custom-blocks/categories') : getTranslation('- Mindre', 'dalslandskanal-custom-blocks/categories')
                        });
                    }}>{toggle.btnText}</button>        
                </li>
            </ul>
            <button className="categories__toggler categories__toggler--more" type="button" onClick={() => {
                setToggle({
                    isOpen: !toggle.isOpen,
                    btnText: toggle.isOpen ? getTranslation('+ Fler', 'dalslandskanal-custom-blocks/categories') :  getTranslation('- Mindre', 'dalslandskanal-custom-blocks/categories')
                });
            }}>{toggle.btnText}</button>
        </div>
    );
};

export default Categories;